// Auto-refactored from translations.js on 2026-08-19
// Locale: sk

const sk = {
  wieMoeglich: { question: 'Ako je to možné?', answer: 'Nanovo sme premysleli hodnotový reťazec.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Cesta STIG ROCK',
    fazit: 'Skrátený dodávateľský reťazec eliminuje najväčšie nákladové položky.',
    fazitBigPre: 'To umožňuje zľavu až',
    fazitBigValue: '80%',
    steps: [ 'Baňa', 'Brusiareň', 'Certifikácia', 'Koncový zákazník' ]
  },
  nav: { language: 'Jazyk', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Jedinečná príležitosť',
    subtitle: 'Budovanie majetku orientované na budúcnosť.',
    description: 'STIG ROCK je medzinárodná platforma, ktorá ľuďom poskytuje prístup k prírodným diamantom, udržateľnému budovaniu majetku a jedinečnej komunite.',
    scroll: 'Rolujte pre objavovanie'
  },
  disclaimer: {
    overline: 'Právne upozornenie',
    title: 'Disclaimer',
    paragraphs: [
      'Táto prezentácia slúži len na informačné účely a nepredstavuje finančné, investičné ani daňové poradenstvo.',
      'STIG ROCK nie je finančný produkt, ale vzťahuje sa na prírodné diamanty ako vecné aktíva.',
      'Za vývoj hodnoty, zisky alebo výnosy sa neposkytuje žiadna záruka. Minulý vývoj nie je indikáciou budúcich výsledkov.',
      'Všetky uvedené výpočty v súvislosti s províziami sú len príkladmi a takisto nepredstavujú žiadnu záruku.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'VYBUDOVANÉ', 'NA ŠTRUKTÚRE' ],
    body: 'STIG Group je medzinárodný koncern postavený na jasnosti, zodpovednosti a dlhodobej hodnote. Každá značka, každý projekt a každé partnerstvo sa riadi jediným štandardom — bez skratiek, bez výnimiek.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'VYBUDOVANÉ', 'NA ŠTRUKTÚRE' ],
        body: 'STIG Group je medzinárodný koncern postavený na jasnosti, zodpovednosti a dlhodobej hodnote. Každá značka, každý projekt a každé partnerstvo sa riadi jediným štandardom — bez skratiek, bez výnimiek.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'SVET', 'EXKLUZÍVNYCH DIAMANTOV' ],
        body: 'STIG ROCK je moderný koncept STIG Group, ktorý spája vysokokvalitné diamanty s certifikáciou GIA s transparentnými štruktúrami a exkluzívnym zákazníckym servisom. Jasné plány riešení, profesionálna realizácia a medzinárodné zameranie.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'MEDZINÁRODNÝ', 'OBCHOD S DIAMANTMI' ],
        body: 'STIG International je súčasťou STIG Group a špecializuje sa na medzinárodný obchod s diamantmi s certifikáciou GIA. Zameranie na kvalitu, dôveru a moderné obchodné štruktúry s globálnymi partnerstvami.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ZODPOVEDNOSŤ', 'UŽ OD BANE' ],
        body: 'Ethical Mines znamená zodpovednú ťažbu, vysledovateľný pôvod a bezkonfliktné diamanty. Od bane až po trh — kompletná dokumentácia pre transparentnosť, integritu a dlhodobú zodpovednosť v celom dodávateľskom reťazci.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanty',
    stigDrawback: 'Skutočný uchovávateľ hodnoty',
    overline: 'Možnosti',
    title: 'Možnosti pre budovanie majetku',
    subtitle: 'Porovnanie tradičných ciest.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex alebo krypto',
        drawback: 'vysoko špekulatívne, nepredvídateľné, komplexné'
      },
      {
        tag: 'Aktcie',
        name: 'Burzový obchod',
        drawback: 'riziko kolísania, potrebné znalosti, časová náročnosť'
      },
      {
        tag: 'Krypto',
        name: 'Obchodovanie',
        drawback: 'volatilita, regulačné riziko, bezpečnostné diery'
      }
    ]
  },
  chance: {
    overline: 'Diamanty',
    title: 'Podceňovaná šanca',
    body: 'Diamanty patria už roky k najstabilnejším formám investícií s vysokým potenciálom, no doteraz tento potenciál využívalo len málo ľudí.',
    callout: 'S našou platformou STIG ROCK prvýkrát otvárame prístup k týmto výnimočným možnostiam pre všetkých.'
  },
  wertentwicklung: {
    overline: 'Vývoj hodnoty 1995 — 2025',
    title: 'Príbeh o hodnote.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamanty',
    diamondValue: '+185%',
    note: 'Vývoj od 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Hlavné dôvody',
    title: 'Šesť dôvodov pre diamanty',
    lead: 'Diamanty sú reálne aktíva, ktoré existujú nezávisle od mien a finančných systémov — a po stáročia si uchovávajú svoju hodnotu.',
    items: [
      {
        n: '01',
        title: 'Stabilita hodnoty v kríze',
        body: 'Garantované vecné aktívum. Nezávislé od mien a finančných systémov.'
      },
      { n: '02', title: 'Ultimátna mobilita', body: 'Malé, ľahko ukryteľné a prenosné.' },
      {
        n: '03',
        title: 'Diverzifikácia a vzácnosť',
        body: 'Nedostatok ponuky a prirodzené obmedzenia.'
      },
      { n: '04', title: 'Dlhodobý rast', body: '+185% od roku 1995.' },
      {
        n: '05',
        title: 'Transparentnosť a exkluzivita',
        body: 'Garantované 4 Cʼs: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerva kráľovských rodov',
        body: 'Aj kráľovské rodiny využívajú diamanty ako majetkovú rezervu.'
      }
    ]
  },
  markt: {
    overline: 'Objem trhu',
    title: '99 — 108 Mrd. USD',
    sub: 'Objem obchodu v roku 2025',
    forecast: 'Prognóza do ~2032 / 2034: cca 140 – 168 Mrd. USD pri miernom raste (~4 – 5 % p.a.).',
    source: 'Zdroj: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovácia',
    title: 'Inovácia. Prvýkrát na svete.',
    body: 'STIG ROCK je prvá platforma na svete, ktorá umožňuje ľuďom dosiahnuť pasívny príjem na trhu s diamantmi popri zhodnotení ich hodnoty.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, SAE',
      'Registračné č. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'O spoločnosti',
    titleLines: [ 'MEDZINÁRODNÁ', 'ŠTRUKTÚRA', 'JASNÁ VÍZIA' ],
    body: 'STIG ROCK bol založený s cieľom urobiť trh s diamantmi transparentnejším, modernejším a orientovaným na zákazníka — so zameraním na dôveru, bezpečnosť a dlhodobú štruktúru.'
  },
  sicherheit: {
    overline: 'Kvalita a bezpečnosť',
    title: 'Gemological Institute of America',
    body: 'Certifikovaná odbornosť pre vaše diamanty. GIA hodnotí každý kameň s najvyššou presnosťou a dlhoročnými skúsenosťami — spoľahlivé znalecké posudky pre našu spoločnosť a našich zákazníkov.',
    transparency: 'Každý diamant spĺňa najvyššie štandardy kvality a je kontrolovaný a certifikovaný renomovanými organizáciami. Každý kameň je jedinečný a má individuálny certifikát.',
    kimberley: 'Kimberley Process — pracujeme výhradne s bezkonfliktnými diamantmi.'
  },
  plaene: {
    overline: 'Solution Plány (SP)',
    title: 'Jedinečná produktová inovácia',
    sub: 'Šesť odstupňovaných Solution plánov — od $1K do $100K+, každý s rastúcou zľavou mesačne a počas celej doby trvania.',
    recommended: 'Obľúbené',
    oneYear: '1 rok',
    rowLabels: {
      delivery: 'Dodacia lehota',
      price: 'Cena produktu',
      carat: 'Karát',
      monthly: 'Zľava (mesiac)',
      totalDiscount: 'Zľava (celkom)',
      duration: 'Doba trvania'
    },
    headers: {
      plan: 'Plán',
      from: 'Od',
      carat: 'Karát',
      monthly: 'Zľava / mesiac',
      total: 'Zľava celkom',
      duration: 'Doba trvania'
    },
    duration: '1 rok',
    footnote: 'Všetky cenové údaje sú bez záruky a závisia od kvality, dopytu a aktuálneho vývoja na trhu. Solution plány sú možné aj na 2 roky.'
  },
  plaeneVIP: {
    overline: 'Solution Plány + VIP balík',
    title: 'S VIP balíkom ešte vyššia zľava',
    sub: 'Celková zľava na plán – v kombinácii s VIP balíkom získate +1% až +3% navyše, čo výrazne zvyšuje celkovú zľavu.',
    rowLabels: {
      delivery: 'Dodacia lehota',
      price: 'Cena produktu',
      carat: 'Karát',
      monthly: 'Zľava (mesiac)',
      totalDiscount: 'Zľava (celkom)',
      vip1: 'VIP balík 1 (+1%)',
      vip2: 'VIP balík 2 (+2%)',
      vip3: 'VIP balík 3 (+3%)'
    },
    footnote: 'Všetky cenové údaje sú bez záruky a závisia od kvality, dopytu a aktuálneho vývoja na trhu.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Vaše možnosti',
    sub: 'Po uplynutí vášho Solution plánu môžete svoje diamanty buď predať späť nám, alebo si ich nechať doručiť domov.',
    options: [
      {
        key: 'deliver',
        title: 'Nechať si doručiť',
        body: 'Diamanty (karát) v cene vášho DS plánu*'
      },
      {
        key: 'sellToUs',
        title: 'Predať nám',
        body: 'Svoje diamanty nám môžete predať späť za nákupnú cenu, ktorú ste zaplatili.'
      },
      {
        key: 'sellThirdParty',
        title: 'Predať tretím stranám',
        body: 'Svoje diamanty môžete predať ďalej tretím stranám.'
      }
    ],
    footnote: '*DS plán znamená Solution plán.'
  },
  tradWeg: {
    overline: 'Tradičný obchod',
    title: 'Tradičná cesta',
    sub: 'Kým sa diamant dostane ku koncovému zákazníkovi, vznikajú v dôsledku sprostredkovateľského, veľkoobchodného a maloobchodného predaja značné marže oproti cene surového diamantu z bane.',
    steps: [
      { title: 'Baňa', subtitle: 'Surové diamanty' },
      { title: 'Sprostredkovateľ', subtitle: 'Nákup surových diamantov' },
      { title: 'Brúsiareň', subtitle: 'Brúsenie na šperkové diamanty' },
      { title: 'Certifikácia', subtitle: 'uznávanými inštitútmi ako GIA' },
      { title: 'Diamantová burza', subtitle: 'Predaj veľkoobchodu' },
      { title: 'Veľkoobchod', subtitle: 'Predaj maloobchodu' },
      { title: 'Maloobchod', subtitle: 'napr. klenotníctva' },
      { title: 'Koncový zákazník', subtitle: 'Kúpa diamantov' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'Cesta STIG ROCK',
    sub: 'Tento cyklus prerušujeme tým, že surové diamanty nakupujeme priamo z bane a nechávame ich brúsiť a certifikovať našimi partnermi. Vďaka tomu môžeme tieto marže odovzdať našim zákazníkom vo forme zľavových dobropisov.',
    duration: '12 mesiacov – doba trvania DS plánu',
    centerBig: '04',
    centerCaption: 'Až 4 obchodné cykly počas trvania DS plánu',
    cycle: [
      { n: '1.', title: 'Nákup viacerých surových diamantov', body: 'pre jeden DS plán' },
      {
        n: '2.',
        title: 'Brúsenie a certifikácia',
        body: 'prostredníctvom našich partnerov'
      },
      { n: '3.', title: 'Predaj koncovým zákazníkom', body: 'a veľkoobchodníkom' },
      { n: '4.', title: 'Tento proces opakujeme', body: 'až 4× ročne' }
    ],
    steps: [
      { title: 'Baňa', subtitle: 'Surové diamanty' },
      { title: 'Brúsiareň', subtitle: 'našimi partnermi' },
      { title: 'Certifikácia', subtitle: 'uznávanými inštitútmi' },
      { title: 'Koncový zákazník', subtitle: 'Kúpa a zľavové dobropisy' }
    ],
    footnote: '*DS plán znamená Solution plán.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP balíky',
    sub: 'Platí 12 mesiacov na všetky vami predplatené Solution plány. V závislosti od VIP balíka: +1% až +3% dodatočná zľava',
    cardKicker: 'dodatočne – na všetky',
    cardKicker2: 'Solution plány',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Zo zliav sa stávajú úspory',
      body: 'Mesačná úspora namiesto mesačnej záťaže. Zo zliav vznikajú úspory – a tie zaplatia presne tie veci, za ktoré inak každý mesiac platíte z vlastného vrecka.',
      line1Label: 'DS plán od',
      line1Value: '$5.000',
      line2Label: 'mes. zľava',
      line2Value: '3%',
      line3Label: 'VIP balík 3',
      line3Value: '+3%',
      resultLabel: 'mes. úspory',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Ako je to možné?',
    title: 'Nanovo sme premysleli hodnotový reťazec.',
    traditionalTitle: 'Tradičná cesta',
    traditionalSteps: [
      'Baňa — Surové diamanty',
      'Sprostredkovateľ — Nákup',
      'Brúsiareň — Brúsenie',
      'Certifikácia (GIA)',
      'Diamantová burza — Veľkoobchod',
      'Veľkoobchod → Maloobchod',
      'Klenotníctva → Koncový zákazník'
    ],
    traditionalNote: 'Kým sa diamant dostane ku koncovému zákazníkovi, vznikajú v dôsledku sprostredkovateľského, veľkoobchodného a maloobchodného predaja značné marže.',
    stigTitle: 'Cesta STIG ROCK',
    stigSteps: [
      'Priamy nákup — Surové diamanty z bane',
      'Brúsenie a certifikácia našimi partnermi',
      'Predaj koncovým zákazníkom a B2B klientom',
      'Až 4 obchodné cykly ročne'
    ],
    stigNote: 'Tento cyklus prerušujeme a marže odovzdávame našim zákazníkom vo forme zľavových dobropisov — až 4 obchodné cykly počas trvania DS plánu.'
  },
  optionen: {
    overline: 'Vaše možnosti',
    title: 'Po uplynutí vášho Solution plánu',
    items: [
      { title: 'Nechať si doručiť', body: 'Diamanty (karát) v cene vášho DS plánu.' },
      { title: 'Predať nám', body: 'Spätný predaj za nákupnú cenu, ktorú ste zaplatili.' },
      { title: 'Predať tretím stranám', body: 'Predaj diamantov na voľnom trhu.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution plány — jedinečná produktová inovácia',
    title: 'Jednoduchá cesta',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registrácia',
        body: 'Kontaktujte svojho odporúčateľa a vytvorte si bezplatný účet!'
      },
      { n: '02', icon: 'cart', title: 'Nákup produktu', body: 'Už od $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Získanie zliav',
        body: 'Získajte mesačné zľavové dobropisy.'
      }
    ]
  },
  business: {
    overline: 'Druhy bonusov',
    title: 'Najjednoduchšia a najférovejšia cesta.',
    sub: 'Päť druhov bonusov — pre váš úspešný rozvoj podnikania.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Až do úrovne 3, od kariérneho stupňa Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Od Sapphire — do nekonečnej hĺbky.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Na Infinity Bonus – do úrovne 5 · BEZ kvalifikácie.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pooly z celosvetového obratu.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Jednorazový bonus v diamantoch (karát).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Tento bonus je vám vyplácaný za každý novo predplatený Solution plán až do 3. úrovne. Jednotlivé úrovne odomykáte s veľmi nízkymi kvalifikáciami.',
    total: 'Až 18% Unilevel Bonus',
    levels: [
      {
        level: 'Úroveň 1',
        value: '10%',
        qual: 'od začiatku',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Úroveň 2',
        value: '5%',
        qual: 'od kariérneho stupňa Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Úroveň 3',
        value: '3%',
        qual: 'od kariérneho stupňa Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Od kariérneho stupňa Sapphire ste kvalifikovaní pre náš Infinity Bonus plán. Získavate 3% bonus. S každým novým kariérnym stupňom pribúdajú ďalšie percentá. Ak je partner vo vašom tíme rovnako kvalifikovaný, získavate rozdiel medzi stupňami.',
    exampleTitle: 'Príklad',
    exampleRows: [
      { label: 'Ste Blue Diamond', value: '12%' },
      { label: 'Váš partner je Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Váš Infinity Bonus', value: '9%' },
    totalNote: 'Celkovo až 24% Infinity Bonus na všetky predplatené Solution plány vo vašom tíme — do nekonečnej hĺbky.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'S týmto bonusom profitujete z úspechu vášho tímu. Získavate Matching Bonus vo výške 5% z Infinity Bonus vašich partnerov — a to až do 5. úrovne vášho tímu.',
    note: 'Na všetky platby Infinity Bonus vo vašom tíme – až do 5. úrovne. Od začiatku – BEZ kvalifikácie.',
    levels: [
      { level: 'Úroveň 1', value: '5%' },
      { level: 'Úroveň 2', value: '5%' },
      { level: 'Úroveň 3', value: '5%' },
      { level: 'Úroveň 4', value: '5%' },
      { level: 'Úroveň 5', value: '5%' }
    ],
    totalPrefix: 'Celkom až',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% celosvetového obratu prúdia rovnakým dielom do 3 rôznych poolov. Dosiahnutím určitých kariérnych stupňov sa kvalifikujete do každého jednotlivého poolu.',
    forever: 'Raz dosiahnuté – NAVŽDY účastníkom!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'od Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'od Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'od Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Celkom',
    totalValue: '3%',
    totalSuffix: 'z celosvetového obratu'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Od kariérneho stupňa Diamond získavate Rang Bonus. Ten sa vypláca v diamantoch (karát). Ide o jednorazový bonus.',
    highlight: 'Diamanty (karát) v celkovej hodnote',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Kariérne stupne',
    title: 'Kariérne stupne',
    sub: 'Pre dosiahnutie príslušných kariérnych stupňov sa započítava historický celkový obrat (HG). Od stupňa Sapphire musí byť tento rozdelený medzi viacero tímov. Pre dosiahnutie stupňa Ruby alebo vyššie potrebujete aspoň dvoch priamych partnerov so STIG ROCK plánom.',
    forever: 'Raz dosiahnuté – NAVŽDY potvrdené!',
    footnote: 'HV = Historický celkový obrat.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 priami partneri', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Začnite s nami',
    title: 'Správny čas je práve teraz.',
    body: 'Tento obchodný model nastavuje nové štandardy a spája všetky faktory úspechu pre dlhodobo udržateľné a úspešné podnikanie. Zaregistrujte sa ešte dnes, vyberte si svoj Solution plán a využite túto jedinečnú obchodnú príležitosť.',
    hint: 'Oslovte osobu, ktorá vás pozvala na túto prezentáciu — má pre vás registračný odkaz.',
    formName: 'Meno',
    formEmail: 'E-mail',
    formPhone: 'Telefón',
    formSubmit: 'Kontaktovať',
    success: 'Ďakujeme — ozveme sa vám diskrétne a osobne.',
    callCta: 'Zavolať',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Právne upozornenie a Disclaimer',
    disclaimer: 'Táto prezentácia slúži len na informačné účely a nepredstavuje finančné, investičné ani daňové poradenstvo. STIG ROCK nie je finančný produkt, ale vzťahuje sa na prírodné diamanty ako vecné aktíva. Za vývoj hodnoty, zisky alebo výnosy sa neposkytuje žiadna záruka. Minulý vývoj nie je indikáciou budúcich výsledkov. Všetky uvedené výpočty v súvislosti s províziami sú len príkladmi a takisto nepredstavujú žiadnu záruku. Zmeny obsahu vyhradené — voľný preklad (nie je to oficiálny preklad).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, SAE',
    copy: '© 2026 STIG International. Všetky práva vyhradené.',
    version: 'Verzia: DS-12-2025 V3'
  },
  misc: { next: 'Nasledujúca sekcia' }
};

export default sk;
